// DonationPanel.jsx — contenedor con pestañas Persona / Empresa.

import React, { Suspense, lazy } from 'react'
import { trackCta } from '../../lib/analytics.js'
import { PersonaPanel } from './PersonaPanel.jsx'

const EmpresaPanel = lazy(() =>
  import('./EmpresaPanel.jsx').then((m) => ({ default: m.EmpresaPanel }))
)

const { useState, useRef, useLayoutEffect } = React;

function DonationPanel({ onDonate, mercadopagoFeeRate, compact = false }) {
  const [tab, setTab] = useState("persona");
  const cardRef = useRef(null);
  const tabRowRef = useRef(null);

  useLayoutEffect(() => {
    const cardEl = cardRef.current;
    const tabRowEl = tabRowRef.current;
    if (!cardEl || !tabRowEl) return;

    function syncTabRowHeight() {
      cardEl.style.setProperty("--tab-row-h", `${tabRowEl.offsetHeight}px`);
    }

    syncTabRowHeight();
    const observer = new ResizeObserver(syncTabRowHeight);
    observer.observe(tabRowEl);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="card-elev" style={{ padding: compact ? 20 : 28 }} ref={cardRef}>
      <div className="tab-pill-row" ref={tabRowRef}>
        <button
          type="button"
          className={`tab-pill ${tab === "persona" ? "active" : ""}`}
          onClick={() => {
            trackCta("tab_persona")
            setTab("persona")
          }}
        >
          Persona
        </button>
        <button
          type="button"
          className={`tab-pill ${tab === "empresa" ? "active" : ""}`}
          onClick={() => {
            trackCta("tab_empresa")
            setTab("empresa")
          }}
        >
          Empresa
        </button>
      </div>
      {tab === "persona" ? (
        <PersonaPanel onDonate={onDonate} mercadopagoFeeRate={mercadopagoFeeRate} />
      ) : (
        <Suspense fallback={null}>
          <EmpresaPanel onDonate={onDonate} mercadopagoFeeRate={mercadopagoFeeRate} />
        </Suspense>
      )}
    </div>
  );
}

export { DonationPanel };
